var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game_tags fs_12 flex_center"},_vm._l((_vm.tags),function(tg){return _c('div',{key:tg.tagId,staticClass:"game_tg"},[(tg.tagType === 1)?_c('div',{staticClass:"tag_1",style:({
        borderColor: tg.labelInfo,
        color: tg.labelInfo,
      })},[_vm._v(_vm._s(tg.labelName))]):_vm._e(),(tg.tagType === 2)?_c('div',{staticClass:"tag_2",style:({
        backgroundColor: tg.background,
        color: tg.labelInfo,
        borderColor: tg.background,
      })},[_vm._v(_vm._s(tg.labelName))]):_vm._e(),(tg.tagType === 3)?_c('div',{staticClass:"tag_3"},[_c('img',{attrs:{"src":tg.pictureTag,"alt":tg.labelName}})]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }